import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { updateExistingInstallYear } from '../actions/form';
import { getExistingInstallYear, getErrors } from '../reducers/form';
import cx from 'classnames';

const mapStateToProps = state => ({
  existingInstallYear: getExistingInstallYear(state),
  errors: getErrors(state),
});
const mapDispatchToProps = dispatch => ({
  updateExistingInstallYear: event =>
    dispatch(updateExistingInstallYear(event.target.value)),
});

const ExistingCaseYear = ({
  existingInstallYear,
  updateExistingInstallYear,
  errors,
}) => {
  const fieldClass = cx('field required', {
    error: errors.includes('existingInstallYear'),
  });

  return (
    <div className="ui segment">
      <div className="two fields">
        <div className={fieldClass}>
          <label>En quelle année a-t-il été installé ?</label>
          <input
            type="text"
            value={existingInstallYear}
            maxLength="4"
            required="true"
            onChange={updateExistingInstallYear}
          />
        </div>
        <div className="field" />
      </div>
    </div>
  );
};

ExistingCaseYear.propTypes = {
  existingInstallYear: PropTypes.number.isRequired,
  updateExistingInstallYear: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExistingCaseYear);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases-creation/step1/components/ExistingCaseYear.js